import role from './role';

export default function(spec) {
  return {
    clip:        spec.clip || false,
    interactive: spec.interactive === false ? false : true,
    marktype:    spec.type,
    name:        spec.name || undefined,
    role:        spec.role || role(spec),
    zindex:      +spec.zindex || undefined
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-parser/src/parsers/marks/definition.js
// module id = null
// module chunks = 